module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB2001-b8d93f641d25cb1fb2c1d204709a00f6.png";